/*******************************************************/
// This file is used to merage all flexible content JS
// File is used for frontend - file meraged in scripts.js
/*******************************************************/


// codekit-append "../inc/flexible-content/sections/section_name/script.js"
// @codekit-append "sections/image-carousel/scripts.js"
// @codekit-append "sections/gallery/scripts.js"
// @codekit-append "sections/slider/scripts.js"
// @codekit-append "sections/posts/scripts.js"
// @codekit-append "sections/map/scripts.js"
// @codekit-append "sections/mailchimp/scripts.js"

jQuery(document).ready(function($) {

});


// WEBPACK FOOTER //
// ./includes/flexible-builder/flexible.js